import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { firebaseAuth } from '../../../providers/AuthProvider';

const GlobalReports = () => {
  const { user } = useContext(firebaseAuth);
  if (!user?.isAuthenticated) return <Navigate to="/manage/sign-in" />;

  return (
    <div className="mx-auto max-w-4xl">
      <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100">Global reports</h1>
      <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-300">
        System-wide global report dashboard coming soon.
      </p>
    </div>
  );
};

export default GlobalReports;
